import { AVDSession } from '../types/session';

interface SessionCardProps {
  session: AVDSession;
  onTerminate: (session: AVDSession) => void;
  isTerminating: boolean;
  showUser?: boolean;
}

function formatDate(dateString?: string): string {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleString('de-AT');
}

export default function SessionCard({
  session,
  onTerminate,
  isTerminating,
  showUser = false,
}: SessionCardProps) {
  return (
    <article className="panel p-5">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="eyebrow">Host Pool</p>
          <h3 className="mt-2 text-lg font-semibold text-ink">{session.hostPoolName}</h3>
          <p className="mt-1 text-sm text-muted">{session.sessionHostName}</p>
        </div>
        <span className="status-pill">{session.sessionState}</span>
      </div>

      <dl className="mt-5 space-y-3 border-t border-line pt-5 text-sm">
        {showUser && (
          <div className="flex justify-between gap-4">
            <dt className="text-muted">Benutzer</dt>
            <dd className="truncate text-ink">{session.userPrincipalName}</dd>
          </div>
        )}
        <div className="flex justify-between gap-4">
          <dt className="text-muted">Erstellt</dt>
          <dd className="text-ink">{formatDate(session.createTime)}</dd>
        </div>
      </dl>

      <button
        onClick={() => onTerminate(session)}
        disabled={isTerminating}
        className="btn-danger mt-5 w-full"
        type="button"
        aria-label={`Sitzung auf ${session.hostPoolName} beenden`}
      >
        {isTerminating ? 'Beendet...' : 'Beenden'}
      </button>
    </article>
  );
}
